<template>
    <main-content with_go_back_bar>
        <template v-slot:action_bar>
            <router-link class="kt-nav__link btn btn-success" :to="'/user-groups/' + cat_id ">
                {{ $t('label.groups') }}
            </router-link>
        </template>
        <users-categories-filter :action="filterAction"></users-categories-filter>
        <kt-datatable v-bind="datatableProps" ref="datatable"></kt-datatable>
    </main-content>
</template>

<script>

import mainContent from "@/components/main-content";
import CatDetailsFilter from "./components/category-details-filter"
import {ApiUrl} from "@/common/api.service";
import {AuthorizationHeader} from "@/common/jwt.service";
import columns from "./datatable/category-details-column";
import actionsColumn from "@/views/user-categories/components/category-details-actions-column";
import toastr from "toastr";
import store from '@/store'
import {mapGetters} from "vuex";

export default {
    name: "user_category_details",
    components: {
        'main-content': mainContent,
        'users-categories-filter': CatDetailsFilter
    },
    data() {
        return {
            cat_id: this.$route.params.hashid,
            query: {}
        }
    },
    computed: {
        datatableProps() {
            return {
                id: "user_categories_datatable",
                data: {
                    type: "remote",
                    source: {
                        read: {
                            url: ApiUrl.path("user/categories/" + this.$route.params.hashid + '/members'),
                            method: "GET",
                            headers: AuthorizationHeader,
                            map: function (res) {
                                return res.data.data;
                            },
                            params: {
                                query: this.query,
                            },
                            success: function (res) {
                                store.commit('user/categorizedUsers', res.data.data)
                            },
                        },
                    },
                    pageSize: 10,
                    serverPaging: true,
                    serverFiltering: true,
                    serverSorting: true,
                },
                layout: {},
                pagination: false,
                sortable: true,
                columns: columns,
                actions: actionsColumn,
            };
        },
        toastr() {
            toastr.options = {
                closeButton: true,
                positionClass: "toast-bottom-center",
                preventDuplicates: true,
                rtl: false
            }

            return toastr
        },
        ...mapGetters('user', [
            'status'
        ])
    },
    methods: {
        filterAction(e, query) {
            this.query = query;
            if (this.$refs.datatable.KTDatatable) {
                this.$refs.datatable.reload();
            }
        }
    }
}
</script>